export function convertEditorFormat(input) {
    try {
        let dumpText = '';
        let isOldFormat = input.hasOwnProperty('time') && input.hasOwnProperty('blocks');
        let isNewFormat = Array.isArray(input) && input.every(item => item.hasOwnProperty('id') && item.hasOwnProperty('type'));
        try {
            if (isOldFormat) {
                return input.blocks.map(block => {
                    let newBlock;
                    if(block.type === 'header') {
                    newBlock = {
                        id: block.id,
                        type: 'heading',
                        props: {
                            textColor: "default",
                            backgroundColor: "default",
                            textAlignment: "left"
                        },
                        content: [],
                        children: []
                    };
                    }else if(block.type === 'list') {
                    
                    const listContent = JSON.stringify(block)
                    newBlock = {
                        id: block.id,
                        type: 'text',
                        props: {
                            textColor: "default",
                            backgroundColor: "default",
                            textAlignment: "left"
                        },
                        content: [{
                            type: 'text',
                            text:'text',
                        }],
                        children: []
                    };
                    }else {
                        newBlock = {
                            id: block.id,
                            type: block.type,
                            props: {
                                textColor: "default",
                                backgroundColor: "default",
                                textAlignment: "left"
                            },
                            content: [],
                            children: []
                        };
                    }
                    try {   
                        if (block.type === "paragraph" || block.type === "header") {
                            newBlock.content.push({
                                type: "text",
                                text: block.data.text,
                                styles: {}
                            });
                        } else if (block.type === "list") {
                            /*
                            newBlock.children = block.data.items.map(item => ({
                                type: "bulletListItem",
                                content: {
                                    type: 'text',
                                    text: item.content
                                },
                                styles: {}
                            }));
                            */
                        } else if (block.type === "image" || block.type === 'simpleImage') {
                            newBlock.props.url = block.data.file.url;
                            newBlock.props.caption = block.data.caption || "";
                        }else {
                            newBlock.content.push({
                                type: "text",
                                text: block.data.text,
                                styles: {}
                            });
                        }
                    }catch(error) {
                        console.error(error.message)
                        console.log(newBlock)
                    }
                    return newBlock;
                });
            } else if (isNewFormat) {
                // No conversion needed, already in the new format
                return input;
            }
        }catch(error) {
            console.error(error.message)
        }
    }catch(error) {
        console.log(input)
    }
}
export function convertEditorJsToHtml(editorJsJson) {
    const data = JSON.parse(editorJsJson);
    let html = '';
    console.log(data)
    data.blocks.forEach(block => {
        switch (block.type) {
            case 'header':
                html += `<h${block.data.level}>${block.data.text}</h${block.data.level}>`;
                break;
            case 'paragraph':
                html += `<p>${block.data.text}</p>`;
                break;
            case 'list':
                html += `<ul>`;
                block.data.items.forEach(item => {
                    html += `<li>${item.content}`;
                    if (item.items && item.items.length > 0) {
                        html += `<ul>`;
                        item.items.forEach(subItem => {
                            html += `<li>${subItem.content}</li>`;
                        });
                        html += `</ul>`;
                    }
                    html += `</li>`;
                });
                html += `</ul>`;
                break;
            case 'simpleImage':
                html += `<img src="${block.data.url}" alt="${block.data.caption}" />`;
                break;
            default:
                // Ignore unknown block types
                break;
        }
    });

    
    return html;
}